// Angular Files
import { CommonModule } from '@angular/common';
import { Component, NgModule, Inject } from '@angular/core';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';

// Angular Material Files
import { MatIconModule } from '@angular/material/icon';
import { MatLegacySnackBarModule, MatLegacySnackBarRef, MAT_LEGACY_SNACK_BAR_DATA } from '@angular/material/legacy-snack-bar';

// Teller Online Library Files
import { TellerOnlineIconsModule } from "teller-online-libraries/icons";

@Component({
    selector: 'teller-online-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss'],
    host: {
        class: 'notification'
    }
})
export class TellerOnlineNotificationComponent {
    // Declare @Input variables

    // Declare @Output variables

    // Public variables

    // Private variables

    // Subscriptions

    constructor(
        @Inject(MAT_LEGACY_SNACK_BAR_DATA) public data: any,
        public snackBarRef: MatLegacySnackBarRef<TellerOnlineNotificationComponent>
    ) {}
}
@NgModule({
    imports: [
        CommonModule,
        TellerOnlineIconsModule,
        MatIconModule,
        MatLegacyButtonModule,
        MatLegacySnackBarModule
    ],
    declarations: [ TellerOnlineNotificationComponent ],
    exports: [ TellerOnlineNotificationComponent ]
})
export class TellerOnlineNotificationModule { }
